<template>
  <svg class="_component-icon-svg" @click="$emit('click')" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="5.05029" width="2" height="16" transform="rotate(-45 4 5.05029)" :style="componentStyle" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 16C3 16 1 10 1 10C1 10 1.58375 8.24876 3.22429 6.63851L4.63848 8.0527C4.53693 8.15199 4.44062 8.25183 4.34931 8.35145C3.80203 8.94848 3.42664 9.54888 3.19064 9.99602L3.18854 10L3.19064 10.004C3.42664 10.4511 3.80203 11.0515 4.34931 11.6486C5.41308 12.809 7.15339 14 10 14C10.195 14 10.3847 13.9944 10.5694 13.9836L12.3405 15.7547C11.6309 15.911 10.8525 16 10 16ZM14.4383 15.0241C17.8919 13.3244 19 10 19 10C19 10 17 4 10 4C7.81078 4 6.11061 4.58686 4.80772 5.3935L6.2723 6.85809C7.23449 6.35124 8.45411 6 10 6C12.8466 6 14.5869 7.19097 15.6507 8.35145C16.198 8.94848 16.5734 9.54888 16.8094 9.99602L16.8115 10L16.8094 10.004C16.5734 10.4511 16.198 11.0515 15.6507 11.6486C15.0135 12.3437 14.1335 13.0498 12.9185 13.5042L14.4383 15.0241Z"
      :style="componentStyle"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8082 12.3941C12.5322 11.8464 13 10.9778 13 10C13 8.34315 11.6569 7 10 7C9.0222 7 8.15365 7.46781 7.60596 8.19182L11.8082 12.3941Z"
      :style="componentStyle"
    />
  </svg>
</template>

<script>
/**
 * @module User 关闭组件
 */
export default {
  name: 'User',
  /**
   * @prop {String} color 颜色
   */
  props: {
    color: {
      type: String,
      default: '#17181A'
    }
  },
  /**
   * @member {Object} componentStyle 组件style
   */
  computed: {
    componentStyle() {
      return {
        fill: this.color
      };
    },
    strokeColor() {
      return this.color === 'none' ? '#494A4D' : this.color;
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
